"use strict";

/*
 * indicative-parser
 *
 * (c) Harminder Virk <virk@adonisjs.com>
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
*/
Object.defineProperty(exports, "__esModule", {
  value: true
});
function getBaseRules(dataType, isOptional) {
  const requiredRule = {
    name: 'required',
    args: []
  };
  const dataTypeRule = {
    name: dataType,
    args: []
  };
  return isOptional ? [dataTypeRule] : [requiredRule, dataTypeRule];
}
exports.getBaseRules = getBaseRules;